// src/redux/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Framework from "../../GuestPages/Framework";

// Async thunk for fetching users
export const fetchFrameworkObject = createAsyncThunk(
  "users/fetchHomeObject",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://cms.recdbase.org/api/request/framework");
      return response.data; // Return the fetched data
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

export const fetchGeneralObject = createAsyncThunk(
    "users/fetchGeneralObject",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get("https://cms.recdbase.org/api/request/general-settings");
        return response.data; // Return the fetched data
      } catch (error) {
        return rejectWithValue(error.response?.data || "An error occurred");
      }
    }
  );
  export const fetchDonationObject = createAsyncThunk(
    "users/fetchDonationObject",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get("https://cms.recdbase.org/api/request/donation-page");
        return response.data; // Return the fetched data
      } catch (error) {
        return rejectWithValue(error.response?.data || "An error occurred");
      }
    }
  );

  export const fetchHomeFaq = createAsyncThunk(
    "users/fetchHomeFaq",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get("https://cms.recdbase.org/api/request/guest-faq");
        return response.data; // Return the fetched data
      } catch (error) {
        return rejectWithValue(error.response?.data || "An error occurred");
      }
    }
  );


const otherSlice = createSlice({
  name: "others",
  initialState: {
    framework: [],
    general: [],
    donation: [],
    homeFaq: null,
    loading: false,

    error: null,
  },
  reducers: {}, // No reducers needed for async API calls
  extraReducers: (builder) => {
    builder
      .addCase(fetchFrameworkObject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFrameworkObject.fulfilled, (state, action) => {
        state.loading = false;
        state.framework = action.payload;
      })
      .addCase(fetchFrameworkObject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

      builder
      .addCase(fetchHomeFaq.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomeFaq.fulfilled, (state, action) => {
        state.loading = false;
        state.homeFaq = action.payload;
      })
      .addCase(fetchHomeFaq.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

      builder
      .addCase(fetchGeneralObject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGeneralObject.fulfilled, (state, action) => {
        state.loading = false;
        state.general = action.payload;
      })
      .addCase(fetchGeneralObject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
      builder
      .addCase(fetchDonationObject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDonationObject.fulfilled, (state, action) => {
        state.loading = false;
        state.donation = action.payload;
      })
      .addCase(fetchDonationObject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default otherSlice.reducer;
